
import { SaleLayoutConf } from "@/models/sale-layout";
import { SaleService } from "@/services";
import { SaleLayoutInfo } from "@/utils/sale-layouts/sale-layout-info";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			items: [] as SaleLayoutInfo[],
			count: 1,
			fetching: false
		};
	},
	props: {
		layout: {
			type: Object as ()=>SaleLayoutConf,
			required: true
		}
	},
	methods: {
		getItemName(item:SaleLayoutInfo):string{
			let date = new Date(item.Name);
			return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
		},
		onScroll(event:any){
			let target = event.target as HTMLElement;
			let scrollBottom = target.scrollTop + target.clientHeight;
			if (scrollBottom > target.scrollHeight - target.clientHeight){
				this.fetch();
			}
		},
		close(){
			this.$emit("close");
		},
		async fetch(){
			if (this.count <= this.items.length){
				return;
			}
			if (this.fetching) return;
			this.fetching = true;
			try{

				let result = await SaleService.getSaleLayoutHistory(this.layout.ID, this.items.length, 50);
				this.items.push(...result.data);
				this.count = result.records;
			}catch(err){

			}
			this.fetching = false;
		},
		async loadSettings(history:SaleLayoutInfo){
			let settings = await SaleService.getSaleLayoutHistoryById(this.layout.ID, history.ID);
			this.$emit("layout", settings.Data);
			this.close();
		}
	},
	async created(){
		await this.fetch();
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
